import { useTranslation } from 'react-i18next';

const rows = [
  { key: 'product', check: 'productCheck' },
  { key: 'qc', check: 'qcCheck' },
  { key: 'warehouse', check: 'warehouseCheck' },
  { key: 'shipping', check: 'shippingCheck' },
  { key: 'coupon', check: 'couponCheck' },
  { key: 'safety', check: 'safetyCheck' },
];

export default function ComparisonTable() {
  const { t } = useTranslation();

  return (
    <section className="w-full px-4 md:px-8 lg:px-12 py-16 md:py-20 bg-warm-50">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-warm-900 mb-3">
            {t('comparison.h2')}
          </h2>
        </div>

        <div className="bg-white rounded-xl border border-warm-200 overflow-hidden">
          <div className="grid grid-cols-2 border-b border-warm-200 bg-warm-50">
            <div className="px-4 md:px-6 py-3.5 text-sm font-semibold text-warm-800 uppercase tracking-wide">
              {t('comparison.factor')}
            </div>
            <div className="px-4 md:px-6 py-3.5 text-sm font-semibold text-warm-800 uppercase tracking-wide">
              {t('comparison.whatToCheck')}
            </div>
          </div>
          {rows.map((row, index) => (
            <div
              key={row.key}
              className={`grid grid-cols-2 ${index < rows.length - 1 ? 'border-b border-warm-100' : ''}`}
            >
              <div className="px-4 md:px-6 py-4 text-sm font-medium text-warm-700">
                {t(`comparison.${row.key}`)}
              </div>
              <div className="px-4 md:px-6 py-4 text-sm text-warm-600">
                {t(`comparison.${row.check}`)}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}